import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import RequireAuth from './components/RequireAuth';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import Signup from './components/Signup';
import Dashboard from './components/Dashboard';
import TeacherDashboard from './components/TeacherDashboard';
import RecordLesson from './components/RecordLesson';
import PracticeTasks from './components/PracticeTasks';
import LessonSummaries from './components/LessonSummaries';
import TeacherLessonSummaries from './components/TeacherLessonSummaries';
import Analytics from './components/Analytics';
import TeacherAnalytics from './components/TeacherAnalytics';
import Awards from './components/Awards';
import TeacherAwards from './components/TeacherAwards';
import StudentProfile from './components/StudentProfile';
import ProfileEdit from './components/ProfileEdit';
import QRCodeScanner from './components/QRCodeScanner';
import ForgotPassword from './components/ForgotPassword';
import TeacherPracticeTasks from './components/TeacherPracticeTasks';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import AdminRoute from './components/AdminRoute';
import Leaderboard from './components/Leaderboard';
import Social from './components/Social';
import Feed from './components/Feed';
import ProfileSetup from './components/ProfileSetup';
import EmailVerification from './components/EmailVerification';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            
            {/* Protected routes */}
            <Route path="/email-verification" element={<RequireAuth><EmailVerification /></RequireAuth>} />
            <Route path="/profile-setup" element={<RequireAuth><ProfileSetup /></RequireAuth>} />
            <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
            <Route path="/teacher/dashboard" element={<RequireAuth><TeacherDashboard /></RequireAuth>} />
            <Route path="/record-lesson" element={<RequireAuth><RecordLesson /></RequireAuth>} />
            <Route path="/teacher/record/:studentId" element={<RequireAuth><RecordLesson /></RequireAuth>} />
            <Route path="/practice-tasks" element={<RequireAuth><PracticeTasks /></RequireAuth>} />
            <Route path="/teacher/practice-tasks" element={<RequireAuth><TeacherPracticeTasks /></RequireAuth>} />
            <Route path="/summaries" element={<RequireAuth><LessonSummaries /></RequireAuth>} />
            <Route path="/teacher/summaries" element={<RequireAuth><TeacherLessonSummaries /></RequireAuth>} />
            <Route path="/teacher/summaries/:studentId" element={<RequireAuth><TeacherLessonSummaries /></RequireAuth>} />
            <Route path="/analytics" element={<RequireAuth><Analytics /></RequireAuth>} />
            <Route path="/teacher/analytics" element={<RequireAuth><TeacherAnalytics /></RequireAuth>} />
            <Route path="/teacher/analytics/:studentId" element={<RequireAuth><TeacherAnalytics /></RequireAuth>} />
            <Route path="/awards" element={<RequireAuth><Awards /></RequireAuth>} />
            <Route path="/teacher/awards" element={<RequireAuth><TeacherAwards /></RequireAuth>} />
            <Route path="/teacher/awards/:studentId" element={<RequireAuth><TeacherAwards /></RequireAuth>} />
            <Route path="/leaderboard" element={<RequireAuth><Leaderboard /></RequireAuth>} />
            <Route path="/social" element={<RequireAuth><Social /></RequireAuth>} />
            <Route path="/feed" element={<RequireAuth><Feed /></RequireAuth>} />
            <Route path="/profile" element={<RequireAuth><StudentProfile /></RequireAuth>} />
            <Route path="/profile/edit" element={<RequireAuth><ProfileEdit /></RequireAuth>} />
            <Route path="/qr-scanner" element={<RequireAuth><QRCodeScanner /></RequireAuth>} />
            <Route path="/teacher/scan" element={<RequireAuth><QRCodeScanner /></RequireAuth>} />
            
            {/* Admin routes */}
            <Route path="/addminn" element={<AdminLogin />} />
            <Route path="/addminn/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
